import { flatten, uniq } from '@lsfe/tools';
import request from '../utils/request-extra';

const $hPost = request({ prefix: '' }).hPost;

export default {
    name: 'permission',
    /**
     * 分二种使用场景 一种是隐藏元素，一种是传入optionList，返回用户有权限的optionList
     * 隐藏元素的用以下这些属性 scope='element'
     * | code    | 线上的权限 code | String, Number, Array | -                                                                                                                                                                                 | ''     | 否       |
     * | devCode | 线下的权限 code | String, Number, Array | -
     * | type    | 多权限code权限校验逻辑,every 用户拥有所有code的权限时候，代表该用户拥有权限,some 用户只要有权限code中的一个权限，就代表该用户有权限| every some | every
     * 传入optionList的是这种 scope='list'
     * listName 传入的是list的名，能从this上获取到的
    */
    async inserted(el, binding, vnode) {
        const { value } = binding;
        const { devCode, code, listName, type = 'every', scope = 'element' } = value;
        const vm = vnode.context;
        const isProd = ['staging', 'production'].includes(process.env.NODE_ENV);
        const innerCode = isProd ? code : devCode || code;
        try {
            if (scope === 'element') {
                const authParmas = flatten([innerCode]);
                let result = await $hPost('/api/auth/check/codePermission', {
                    authCodeList: [...authParmas],
                    systemSource: 0
                }, { cache: true });
                result = result.authList;
                const authResult = Array.prototype[type].call(result || [], item => item.res);
                if (!authResult) {
                    el.parentNode && el.parentNode.removeChild(el);
                }
            }

            if (scope === 'list') {
                const getCode = item => (isProd ? item.code : item.devCode);
                const permissonCodes = uniq(vm[listName].map(v => getCode(v))).filter(Boolean);
                let result = await $hPost('/api/auth/check/codePermission', {
                    authCodeList: [...permissonCodes],
                    systemSource: 0
                }, { cache: true });
                result = result.authList;
                vm[listName] = vm[listName].filter(item => {
                    const permissionCode = getCode(item);
                    if (permissionCode) {
                        const authItem = result.find(v => v.authCode === permissionCode) || {};
                        return authItem.res;
                    }
                    return true;
                });
            }

        } catch (e) { }
    }
};
